import { createAction, types } from "redux-act";
types.disableChecking();
export default function createMetaAction(actionName, payloadHelper) {
  return createAction(actionName, payloadHelper, function(unused, meta) {
    return {
      ...meta,
      editorName: meta.editorName
    };
  });
}
